import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import Card from '../Card'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import PricingTableList from '../PricingTable/PricingTableList'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import Spacing from '../Spacing'
import { getServicesData } from '../../data/servicesData.js'
import { updateMetaTags } from '../../helper/updateMetaTags'
import { Helmet } from 'react-helmet'

export default function ServicesPage(props) {
  const { t, i18n } = useTranslation();
  const servicesData = getServicesData(i18n.language === 'en' ? 'en' : 'cs');

  useEffect(() => {
    if (props.id === 'cenik') {
      document.title = t('services.pricingMetaTitle');
      document.getElementById('cenik')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0)
    }

  }, [props.id, t])
  return (
    <>
        <Helmet>
        <title>
          {props.id === 'cenik'
            ? t('services.pricingMetaTitle')
            : t('services.metaTitle')}
        </title>
        <link rel="icon" href="/stablerecords.ico" />
        <meta name="description" content={
          props.id === 'cenik'
            ? t('services.pricingMetaDescription')
            : t('services.metaDescription')}
        />
      </Helmet>
      <div>
        {updateMetaTags(t('services.ogDescription'), t('services.ogKeywords'))}
      </div>
      <PageHeading
        title={t('services.pageTitle')}
        bgSrc='images/service_hero_bg.jpeg'
        pageLinkText={t('services.pageTitle')}
      />
      <Spacing lg='150' md='80'/>
      <Div className='cs-shape_wrap_4'>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title={t('services.sectionTitle')}
                subtitle={t('services.sectionSubtitle')}
              />
              <Spacing lg='90' md='45'/>
            </Div>
            <Div className="col-xl-8">
              <Div className="row">
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title={servicesData[2].name}
                    link={"/sluzby/" + servicesData[2].id}
                    src={servicesData[2].src}
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title={servicesData[1].name}
                    link={"/sluzby/" + servicesData[1].id}
                    src={servicesData[1].src}
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title={t('home.studioRental')}
                    link={"/sluzby/" + servicesData[3].id}
                    src={servicesData[3].src}
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title={t('home.accommodation')}
                    link={"/sluzby/" + servicesData[0].id}
                    src={servicesData[0].src}
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <div id="cenik">
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <SectionHeading
          title={t('services.pricingTitle')}
          subtitle={t('services.pricingSubtitle')}
        />
        <Spacing lg='85' md='40'/>
          <PricingTableList />
      </Div>
      </div>
      <Spacing lg='150' md='55'/>
      <Div className="container">
        <Cta
          title={t('services.ctaTitle')}
          btnText={t('services.ctaBtn')}
          btnLink={'/kontakt'}
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}